import * as types from "../../types/dashboard/dashboard";

export const requestDashboardData = () => ({
  type: types.DASHBOARD_DATA_REQUEST,
});
export const receiveDashboardData = (payload) => ({
  type: types.DASHBOARD_DATA_RECEIVE,
  payload,
});

export const requestDashboarPlansdData = () => ({
  type: types.DASHBOARD_PLANS_REQUEST,
});
export const receiveDashboarPlansdData = (payload) => ({
  type: types.DASHBOARD_PLANS_RECEIVE,
  payload,
});

export const reportDataRequest = payload => ({
  type: types.REPORT_DATA_REQUEST,
  payload
});

export const reportDataRecieve = payload => ({
  type: types.REPORT_DATA_RECIEVE,
  payload
});


export const exportExcelRequest = payload => ({
  type: types.EXPORT_EXCEL_REQUEST,
  payload
});

export const exportExcelRecieve = payload => ({
  type: types.EXPORT_EXCEL_RECIEVE,
  payload
});

export const exportCvsRequest = payload => ({
  type: types.EXPORT_CVS_REQUEST,
  payload
});

export const exportCvsRecieve = payload => ({
  type: types.EXPORT_CVS_RECIEVE,
  payload
});

export const requestDashboarPackagesData = () => ({
  type: types.DASHBOARD_PACKAGES_REQUEST,
});
export const receiveDashboardPackagesData = () => ({
  type: types.DASHBOARD_PACKAGES_RECIEVE,
});
